export default __webpack_public_path__ + "static/synchronized-calendar-m-064d3daa7d11dcdbf810a482df2f0cd3.webp";